import React from "react";
import Pagination from 'react-bootstrap/Pagination';
import {useDispatch} from "react-redux";
import {setPage} from "../../store/yearbook/yearbookSearchSlice";

const YearbookSearchPaginator = ({props}) => {

    const { data, page } = props;

    const dispatch = useDispatch();

    const _isCurrent = (p) => {
        return data ? p === page : false;
    }

    const changePage = (page) => {
        dispatch(setPage(page));
    }

    return (
        <>
            {
                data ?
                <div className="d-flex justify-content-start">
                                <Pagination>
                                    <Pagination.First disabled={page === 1} onClick={() => changePage(1)}/>
                                    <Pagination.Prev disabled={page <= 1} onClick={() => changePage(page - 1)}/>
                                    {data?.paginator.elied_page_range && data?.paginator.elied_page_range.map((p) => {
                                        return typeof (p) === "number" ?
                                            <Pagination.Item active={_isCurrent(p)} key={p} onClick={() => changePage(p)}>{p}</Pagination.Item> :
                                            <Pagination.Ellipsis/>
                                    })}
                                    <Pagination.Next disabled={page >= data?.paginator.num_pages} onClick={() => changePage(page + 1)}/>
                                    <Pagination.Last disabled={page === data?.paginator.num_pages} onClick={() => changePage(data?.paginator.num_pages)}/>
                                </Pagination>
                            </div>
                : null
            }
        </>
    )

}

export default YearbookSearchPaginator;
